import React from 'react'
import { OverlayTrigger, Tooltip, Table } from 'react-bootstrap'
import { v4 as uuidv4 } from 'uuid'

const Community = ({ data, brandArr }) => {
  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      計算用戶對於粉絲專頁的互動和點擊情況，以了解用戶對專頁內容的興趣。計算方式：用戶點擊你任何內容的次數/與你社群互動交流(包括任何點擊)的用戶人數。
    </Tooltip>
  )

  return (
    <>
      <Table striped hover>
        <thead>
          <tr>
            <th scope="col" className="fs-5">
              <h4 className="fw-bolder">
                社群漲粉率
                <OverlayTrigger
                  placement="right"
                  delay={{ show: 50, hide: 400 }}
                  overlay={renderTooltip}
                >
                  <div
                    className="fas fa-question-circle p-1 text-decoration-none"
                    data-bs-toggle="tooltip"
                    data-bs-placement="right"
                    // data-bs-title="Lorem ipsum"
                  ></div>
                </OverlayTrigger>
              </h4>
            </th>
            {/* <th>{data.count_fans}</th> */}
          </tr>
        </thead>
        <tbody className="table-group-divider">
          {brandArr.map((v) => {
            return (
              <tr key={uuidv4()}>
                <th scope="row">{v.title} 漲粉率</th>
                <td>{data[`fans_grow_${v.brand}`]} %</td>
              </tr>
            )
          })}
        </tbody>
      </Table>
    </>
  )
}

export default Community
